import axios from '../base/axios';
import API_KEY from './key';

const GET_TVANIMATION = 'flixfrenzy/redux/GET_TVANIMATION';

// eslint-disable-next-line default-param-last
const tvAnimationReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVANIMATION:
      return action.payload;
    default:
      return state;
  }
};

export const getTvAnimation = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=16`).then((res) => {
    dispatch({
      type: GET_TVANIMATION,
      payload: res.data,
    });
  });
};

export default tvAnimationReducer;
